
import AppBankEdit from "@/components/bank/QuickEdit.vue";
import AppBrowse from "@/components/browse/Browse.vue";
import AppSaleReminder from "@/components/sales/ReminderSend.vue";
import AppReminderAutoSend from "@/components/sales/ReminderAutoSend.vue";
import AppSendSale from "@/components/sales/SaleSendModal.vue";
import {Sale} from "@/models/base";
import { BrowseService } from "@/services/browse-service";
import { SaleService } from "@/services/sale-service";
import { ToolbarService } from "@/services/toolbar-service";
import { IBrowseDataSource } from "@/utils/browse/browse-data-source";
import { BrowseState } from "@/utils/browse/browse-state";
import Vue from "vue";
import { ISelectItem } from "winfakt-vue-components";
import { UserConfigService } from "../../services/user-config-service";
import { UblService } from "@/plugins/ubl/services/ubl-service";
import { AuthService } from "../../services/auth-service";
import { MODULE } from "../../config/modules";
import { View } from "@/models/view";
import AppPublicLink from "@/components/PublicLink.vue";
import AppSendPortal from "@/components/client-portal/PortalSendModal.vue";
import AppCreateUblArchiveModal from "@/components/settings-default/CreateUblArchiveModal.vue";
import AppCreatePdfArchiveModal from "@/components/pdf-archive/CreatePdfArchiveModal.vue";
import AppSaveAsModal from "@/components/sales/SaveAsModal.vue";
import { CustomerService } from "@/services/customer-service";
import AppCombinedSaleSpinnerModal from "@/components/sales/CombinedSaleSpinnerModal.vue";
import { FetchedTotal } from "@/utils/views/fetched-total";
import AppSendViaPeppolModal from "@/components/sales/SendViaPeppolModal.vue";
import AppCreateDagontvangstModal from "@/components/sales/CreateDagontvangstModal.vue";
import AppChangeFriendlyIdModal from "@/components/sales/ChangeFriendlyIdModal.vue";
import AppDeletedSalesBrowse from "@/components/sales/DeletedSalesBrowse.vue";
import {DossierConfigService, JobService, MainSocketService} from "@/services";
import { CarpassService } from "@/services/carpass-service";
import { CarpassInputModalState } from "@/utils/carpass-input-modal-state";
import AppCarpassInputModal from "@/components/cars/CarpassInputModal.vue";
import { PrintContext, SalePrintSettings } from "@/utils/sale-layouts/print-settings";
import { ObservationStatus } from "@/utils/carpass/observation-status";
import AppCarpassObservationDescriptionModal from "@/components/cars/CarpassObservationDescriptionModal.vue";
import { Tier } from "@/utils/payments/tiers";
import {SendcloudService} from "@/services/sendcloud-service";
import { isSaleTypeAllowedForBankBookings } from "@/utils/bank-booking-sale-types";
import AppCreateSendcloudParcel from "@/components/sendcloud/CreateSendCloudParcel.vue";
import AppSaleSendCloudParcels from "@/components/sendcloud/SaleSendCloudParcels.vue";
import AppAddDepositModal from "@/components/sales/AddDepositModal.vue";
import AppSaleEditDeliveryDateModal from "@/components/sales/EditDeliveryDateModal.vue";
import AppSaleSaveToModal from "@/components/sales/SaleSaveToModal.vue";
import AppSalePrintSelectLayoutModal from "@/components/sales/SalePrintSelectLayoutModal.vue";
import AppFillLedgerAccountsModal from "@/components/sales/FillLedgerAccountsModal.vue";
import AppConvertToCreditNoteModal from "@/components/sales/ConvertToCreditNoteModal.vue";
import { newNullOrDate } from "@/utils/date-utils";
import { CtepService } from "@/services/ctep-service";
import { printPdf } from "@/utils/pdf";
import { CtepEctError } from "@/utils/ctep/ctep-ect-error";
import { Permissions } from "@/models/user-configs/permissions";

export default Vue.extend({
	data() {
		return {
			AuthService,
			quickBankEditSale: null as null | Sale,
			saleReminder: false,
			convertToCreditNoteModal: false,
			sendModal: false,
			sendPortalModal: false,
			clientPortalLink: "",
			toSendSale: null as Sale | null,
			toSendEmailAddress: "",
			publicLinkModal: false,
			publicLink: "",
			browseState: null as null | BrowseState,
			selectedItems: SaleService.selectedSales,
			createUblArchiveModal: false,
			ublArchiveSelectedIds: [] as number[],
			createPdfArchiveModal: false,
			saveAsModal: false,
			autoSendReminders: false,
			showCombinedSalePrintingLayoutSelect: false,
			combinedSalePrintingLayoutId: null as number | null,
			isPrintingCombinedSale: false,
			createDagontvangstModal: false,
			peppolModalOpen: false,
			changeFriendlyIdModalOpen: false,
			deletedSalesModal: false,
			carpassInputModalState: new CarpassInputModalState(),
			carpassEditObservationDescriptionSale: null as null | Sale,
			toSendViaSendcloudSale: null as null | Sale,
			sendcloudBrowseSale: null as null | Sale,
			addDepositModalSale: null as null | Sale,
			editDeliveryDateModalSale: null as null | Sale,
			saveToModalOpen: false,
			fillLedgerAccountsModalOpen: false,
			selectedContextMenuItem: null as null | Sale
		};
	},
	props: {
		browseId: Number,
		controlsDisabled: Boolean,
		searchEnabled: Boolean
	},
	computed: {
		// eslint-disable-next-line max-lines-per-function
		dataSource(): IBrowseDataSource<Sale> {
			let elem = this;
			return {
				getSettings: () => BrowseService.getBrowse(this.browseId),
				getFullElement: (el:Sale) => SaleService.getSale(el.ID),
				getElements: (params) => SaleService.getSales(params),
				getTotals(view:View):Promise<FetchedTotal[]>{
					return SaleService.getTotals(view);
				},
				edit(sale: Sale) {
					elem.$router.push(`/sales/edit/${sale.ID}`);
				},
				duplicate(sale: Sale) {
					elem.$router.push(`/sales/duplicate/${sale.ID}`);
				},
				canEdit(sale: Sale): boolean {
					return sale.canEdit();
				},
				canDuplicate(): boolean {
					return true;
				},
				canDelete(sales:Sale[]):boolean {
					let confs = DossierConfigService.getSaleConfigs();
					for (let s of sales){
						if (!s.canEdit()) return false;
						let conf = confs.getConfig(s.TypeID);
						if (conf.DontAllowDelete) return false;
					}
					return true;
				},
				async delete(sales: Sale[]) {
					let haveBanks = await SaleService.salesHaveBanks(sales);
					if (haveBanks) {
						let confirm = await elem.$confirmBuilder(elem.$ct("confirm-delete-with-payments")).setWarningTitle().show();
						if (!confirm) {
							return false;
						}
					}
					if (sales.length > 1){
						let job = await SaleService.delSales(sales);
						JobService.once(`job-stopped/${job.getID()}`, ()=>elem.removeDeletedSales());
						elem.$wf.notify(elem.$ct("document-delete-job-started"), "info", 3000, "info-circle");
						return true;
					}
					await SaleService.delSale(sales[0]);
					return true;
				},
				info(sale: Sale) {
					elem.$router.push(`/sales/info/${sale.ID}`);
				},
				addRoute(view: View) {
					let newTypeID = view.MetaData.NewSaleTypeID || 1;
					return `/sales/new?typeId=${newTypeID}`;
				},
				browseName: "Sales",
				modelName: "Sale",
				browsePermissions: ()=> UserConfigService.getPermissionSettings().SalePermissions,
				getOnElementUpdateSocketEvent: (item:Sale)=>`/sale/${item.ID}/update`,
				onSocketElementUpdated: (data:any)=>new Sale(data),
				extraFieldSettings: {
					getExtraFields: SaleService.getExtraFields.bind(SaleService),
					nameSettings: DossierConfigService.getExtraFieldNamesConfigs().SaleNames,
					batchEdit: SaleService.batchEditExtraField.bind(SaleService),
					edit: (SaleService.updateExtraFields as any).bind(SaleService)
				},
			};
		},
		createDagontvangstItem():ISelectItem<string>{
			return {
				text: this.$ct("create-dagontvangst"),
				value: "opencreateDagontvangstModal",
				icon: "file-invoice-dollar",
				disabled: !AuthService.hasModule(MODULE.DAGONTVANGSTEN)
			};
		},
		createPdfArchiveItem():ISelectItem<string>{
			return {
				text: this.$ct("createPdfArchive"),
				value: "createPdfArchive",
				icon: "file-pdf",
				disabled: !AuthService.hasModule(MODULE.UITGESTELD_MAILEN)
			};
		},
		saveToItem():ISelectItem<Function>{
			return {
				text: this.$ct("save-to"),
				value: ()=>this.saveToModalOpen = true,
				icon: "clone",
			};
		},
		fillLedgerAccountsItem():ISelectItem<Function>{
			return {
				text: this.$ct("fill-ledger-accounts"),
				value: this.openFillLedgerAccountsModal,
				icon: "book",
			};
		},
		changeComputedFriendlyIDItem():ISelectItem<string>{
			return {
				text: "Nummer veranderen",
				value: "openChangeComputedFriendlyIdModal",
				icon: "cog"
			};
		},
		checkCarpassStatusItem():ISelectItem<string>{
			let disabled = true;
			let selectedItem = this.firstSelectedItem;
			if (selectedItem && selectedItem.CarpassRequestId) {
				disabled = false;
			}
			return {
				text: this.$ct("check-carpass-status"),
				value: "checkCarpassStatus",
				icon: "car",
				disabled
			};
		},
		addCarpassDescriptionItem():ISelectItem<string>{
			let disabled = true;
			let selectedItem = this.firstSelectedItem;
			if (selectedItem && selectedItem.CarpassRequestId &&
				(selectedItem.CarpassStatus == ObservationStatus.PROCESSED || selectedItem.CarpassStatus == ObservationStatus.ISSUE)) {
				disabled = false;
			}
			return {
				text: this.$ct("add-carpass-description"),
				value: "addCarpassDescription",
				icon: "car",
				disabled
			};
		},
		shouldDisableSendSale():boolean {
			if (this.selectedItems.length == 1) {
				return false;
			}
			if (AuthService.wfCompany.Tier < Tier.ENTERPRISE){
				return true;
			}
			return false;
		},
		shouldDisableSendSaleUbl():boolean {
			return this.selectedItems.length > 1 && !AuthService.hasModule(MODULE.EXPORT_NAAR_EXTERN_BOEKHPAKKET);
		},
		shouldDisableProcessPayment():boolean {
			if (!this.firstSelectedItem) {
				return false;
			}
			return !isSaleTypeAllowedForBankBookings(this.firstSelectedItem.TypeID);
		},
		sendViaSendcloudItems():ISelectItem<string | Function>[] {
			if (!AuthService.hasModule(MODULE.SENDCLOUD)) return [];
			if (!SendcloudService.isConfigured()) return [];
			return [
				{
					text: this.$ct("send-via-sendcloud"),
					value: this.sendViaSendcloud,
					icon: "shipping-fast"
				},
				{
					text: this.$ct("sent-sendcloud-parcels"),
					value: this.openSendcloudParcelsList,
					icon: "truck"
				}
			];
		},
		ownerItems():ISelectItem<string | Function>[] {
			let result:ISelectItem<string | Function>[] = [];
			if (!AuthService.wfDossier.settings.DeletedSalesDisabled || AuthService.isDevModeEnabled){
				result.push({
					text: "Verwijderde documenten bekijken",
					value: this.openDeletedSalesModal,
					icon: "ban",
					disabled: !UserConfigService.hasCurrentUserPermission((p:Permissions)=>{
						return p.IsAdmin;
					})
				});
			};
			return result;
		},
		devModeItems():ISelectItem<string | Function>[] {
			let result:ISelectItem<string | Function>[] = [
				{
					text: "Document import referenties herstellen",
					value: this.fixImportedInDocument,
					icon: "wrench",
					disabled: this.selectedItems.length == 0
				},
			];
			if (this.selectedItems.length == 1) {
				result.unshift(this.changeComputedFriendlyIDItem);
			}
			return result;
		},
		peppolSendAction():ISelectItem<Function>{
			let disabled = false;
			let selectedItem = this.getSelectedItem(this.selectedContextMenuItem);
			if (!AuthService.hasModule(MODULE.ELECTRONISCHE_FACTURATIE)){
				disabled = true;
			}else if (this.selectedItems.length > 1) {
				disabled = true;
			}else if (!selectedItem || selectedItem.isSaldoDocument()) {
				disabled = true;
			}
			return {
				text: this.$ct("peppol-send"),
				value: this.sendViaPeppol,
				icon: "project-diagram",
				disabled,
			};
		},
		fetchLastSaleTransactionItem():ISelectItem<Function>{
			return {
				text: this.$ct("last-ctep-transaction"),
				value: this.fetchLastCtepTransaction,
				icon: "credit-card",
			};
		},
		// eslint-disable-next-line max-lines-per-function
		singleItemActions(): ISelectItem<string | Function>[] {
			let items: ISelectItem<string | Function>[] = [
				{
					text: this.$ct("print-sale"),
					value: "printSale",
					icon: "print"
				},
				{
					text: this.$ct("download-sale"),
					value: "downloadSale",
					icon: "download"
				},
				{
					text: this.$ct("share-sale"),
					value: "shareSale",
					icon: "share-alt",
					disabled: !(navigator.canShare)
				},
				{
					text: this.$ct("email-sale"),
					value: "sendSale",
					icon: "envelope",
					disabled: this.shouldDisableSendSale
				},
				this.peppolSendAction,
				{
					text: this.$ct("email-sale-to-bookkeeper"),
					value: "sendSaleUbl",
					icon: "user-tie",
					disabled: this.shouldDisableSendSaleUbl
				},
				{
					text: this.$ct("email-sale-portal"),
					value: "sendPortal",
					icon: "folder-open",
					disabled: !AuthService.hasModule(MODULE.CLIENT_PORTAL)
				},
				{
					text: this.$ct("process-payment").toString(),
					value: "processPayment",
					icon: "euro-sign",
					disabled: this.shouldDisableProcessPayment
				},
				{
					text: this.$ct("send-reminder"),
					icon: "history",
					value: "sendReminder"
				},
				{
					text: this.$ct("public-url-create").toString(),
					value: "createPublicLink",
					icon: "globe"
				},
				{
					text: this.$ct("download-ubl"),
					value: "downloadUbl",
					icon: "file-invoice",
					disabled: !AuthService.hasModule(MODULE.EXPORT_NAAR_EXTERN_BOEKHPAKKET)
				},
				{
					text: this.$ct(this.selectedItems.length == 1 ? "convert-to-single-credit-note" : "convert-to-credit-note"),
					value: "convertToCreditNote",
					icon: "money-check-alt"
				},
				{
					text: this.$ct("save-as"),
					value: "saveAs",
					icon: "save"
				},
				{
					text: this.$ct("add-deposit"),
					value: "addDeposit",
					icon: "money-check-alt",
					disabled: !AuthService.hasModule(MODULE.VOORSCHOTVERWERKING)
				},
				this.createDagontvangstItem,
			];
			items.push(...this.sendViaSendcloudItems);

			if(AuthService.hasModule(MODULE.OPSLAAN_NAAR)){
				items.push(this.saveToItem);
			}

			if (AuthService.hasModule(MODULE.BOEKHOUDLIJSTEN)){
				items.push(this.fillLedgerAccountsItem);
			}

			if (DossierConfigService.getCarpassConfig().isConfigured()) {
				items.push(this.checkCarpassStatusItem, this.addCarpassDescriptionItem);
			}

			if (AuthService.isDevModeEnabled){
				items.push(...this.devModeItems);
			}

			items.push(...this.ownerItems);
			return items;
		},
		showCtepItems():boolean{
			if (!AuthService.hasModule(MODULE.KOPPELING_MET_BANCONTACT)) return false;
			return CtepService.getSettings().mode == "cloud";
		},
		// eslint-disable-next-line max-lines-per-function
		buttonBarItems(): ISelectItem<string | Function>[] {
			let items = [];
			if (this.selectedItems.length == 1) {
				return this.singleItemActions;
			}
			items.push({
				text: this.$ct("send-auto-reminders"),
				value: "sendAutoReminders",
				icon: "history",
				disabled: !AuthService.hasModule(MODULE.AUTOMATISCHE_HERINNERINGSBRIEVEN)
			});

			items.push(this.createDagontvangstItem);

			items.push({
				text: this.$ct("create-ubl-archive-for-accountant"),
				value: "createUblArchive",
				icon: "archive",
				disabled: (!AuthService.hasModule(MODULE.BOEKHOUDLIJSTEN) && !AuthService.hasModule(MODULE.EXPORT_NAAR_EXTERN_BOEKHPAKKET))
			});
			items.push(this.createPdfArchiveItem);
			items.push({
				text: this.$ct("download-ubl"),
				value: "downloadUbl",
				icon: "file-invoice",
				disabled: !AuthService.hasModule(MODULE.EXPORT_NAAR_EXTERN_BOEKHPAKKET) || this.selectedItems.length == 0
			});
			if(AuthService.hasModule(MODULE.OPSLAAN_NAAR)){
				items.push(this.saveToItem);
			}
			if (AuthService.hasModule(MODULE.BOEKHOUDLIJSTEN)){
				items.push(this.fillLedgerAccountsItem);
			}
			if (AuthService.isDevModeEnabled){
				items.push(...this.devModeItems);
			}
			if(this.isOwner){
				items.push(...this.ownerItems);
			}
			if (this.showCtepItems){
				items.push(this.fetchLastSaleTransactionItem);
			}

			return items;
		},
		firstSelectedItem(): Sale {
			return this.selectedItems[0];
		},
		contextMenuItems(): ISelectItem<string | Function>[] {
			return this.singleItemActions;
		},
		selectedContactId(): number {
			if (!this.selectedItems[0]) {
				return 0;
			}
			return this.selectedItems[0].ContactID;
		},
		isOwner(): boolean {
			return this.AuthService.wfCompany.OwnerID == this.AuthService.wfUser.ID;
		},
	},
	watch: {
		"$route.path": {
			immediate: true,
			handler(){
				if (this.$route.path == "/sales"){
					ToolbarService.title = this.$ct("sales");
				}
			}
		}
	},
	methods: {
		async fixImportedInDocument(item?:Sale){
			let items = this.selectedItems;
			if (item) {
				items = [item];
			}
			await SaleService.fixImportedInSales(items.map(i=>i.ID));
		},
		getSelectedItem(item?: Sale | null): Sale | undefined {
			if (item) {
				return item;
			}
			if (this.firstSelectedItem) {
				return this.firstSelectedItem;
			}
			return undefined;
		},
		processPayment(item?: Sale) {
			item = this.getSelectedItem(item);
			if (!item) return;
			if (!isSaleTypeAllowedForBankBookings(item.TypeID)) {
				this.$wf.notify(this.$t("components.bank.booking-not-allowed-for-sale-type").toString(), "danger", 3000, "exclamation-triangle");
				return;
			}
			this.quickBankEditSale = item;
		},
		sendReminder(item?: Sale) {
			item = this.getSelectedItem(item);
			if (!item) return;
			if (this.selectedItems.length === 0) {
				this.selectedItems.push(item);
			}
			this.saleReminder = true;
		},
		sendAutoReminders() {
			this.autoSendReminders = true;
		},
		cancelSelection() {
			if (!this.browseState) return;
			this.browseState.emptySelectedItems();
		},
		updateView() {
			if (!this.browseState) return;
			this.browseState.fetch();
		},
		clearSelection(){
			if (!this.browseState) return;
			this.browseState.emptySelectedItems();
		},
		async closeSaleReminder(saleIds:number[]) {
			this.saleReminder = false;
			if (!this.browseState) return;
			await this.browseState.refreshSpecificRecords(saleIds);
		},
		async createPublicLink(item: Sale) {
			this.publicLinkModal = true;
			this.publicLink = await SaleService.generatePublicUrl(item);
		},
		closePublicLink() {
			this.publicLinkModal = false;
			this.publicLink = "";
		},
		async downloadUbl(sale?: Sale) {
			let sales = [...this.selectedItems];
			if (this.selectedItems.length == 0) {
				let selectedItem = this.getSelectedItem(sale);
				if (!selectedItem) return;
				sales = [selectedItem];
			}
			if (sales.length == 1) {
				await UblService.downloadInvoiceUbl(this, sales[0]);
			}else{
				await UblService.createArchive(this, {saleIds: sales.map(s=>s.ID)});
			}
		},
		async createUblArchive() {
			this.ublArchiveSelectedIds = this.selectedItems.map(s=>s.ID);
			this.createUblArchiveModal = true;
		},
		async createPdfArchive() {
			this.createPdfArchiveModal = true;
		},
		async printSale(item?: Sale) {
			if (this.selectedItems.length > 1 && AuthService.hasModule(MODULE.UITGESTELD_AFDRUKKEN)){
				if (this.isPrintingCombinedSale) return;
				if(this.combinedSalePrintingLayoutId == null){
					this.combinedSalePrintingLayoutId = 0;
					this.showCombinedSalePrintingLayoutSelect=true;
					return;
				}
				this.showCombinedSalePrintingLayoutSelect = false;
				this.isPrintingCombinedSale = true;
				try{
					await SaleService.printSalesMultiple(this.selectedItems.map(s=>s.ID),this.combinedSalePrintingLayoutId);
				}catch(err){
				}
				this.isPrintingCombinedSale = false;
				this.combinedSalePrintingLayoutId = null;
				return;
			}

			item = this.getSelectedItem(item);
			if (!item) return;
			if (this.validateSaldoDocuments(item)) {
				return;
			}
			await SaleService.printSale(item);
		},
		async downloadSale(item?: Sale) {
			item = this.getSelectedItem(item);
			if (!item) return;
			if (this.validateSaldoDocuments(item)) {
				return;
			}
			await SaleService.downloadAndSaveSale(item, item.LayoutID, new SalePrintSettings(PrintContext.DOWNLOAD));
		},
		async shareSale(item?: Sale) {
			item = this.getSelectedItem(item);
			if (!item) return;
			if (this.validateSaldoDocuments(item)) {
				return;
			}
			await SaleService.shareSale(item, item.LayoutID);
		},
		async sendSale(item?: Sale) {
			if (this.shouldDisableSendSaleUbl) return;
			if (this.selectedItems.length > 1) {
				if (this.selectedItems.length > 100) {
					this.$wf.notify(this.$ct("you-can-only-send-up-to-x-sales"), "danger", 3000, "exclemation-triangle");
					return;
				}
				let message = this.$ctc("are-you-sure-you-want-to-send-x-documents", this.selectedItems.length, {count: this.selectedItems.length});
				let confirm = await this.$confirmBuilder().setWarningTitle().setMessage(message).show();
				if (!confirm) return;
				await SaleService.batchSend(this.selectedItems);
				this.$wf.notify(this.$ct("send-started-follow-in-notifications"), "info", 5000, "info-circle");
				return;
			}
			item = this.getSelectedItem(item);
			if (!item) return;
			if (this.validateSaldoDocuments(item)) {
				return;
			}
			this.toSendSale = await SaleService.getSale(item.ID);
			this.sendModal = true;
		},
		async sendSaleUbl(item?: Sale) {
			if (this.shouldDisableSendSaleUbl) return;
			let selectedItems = [...this.selectedItems];
			if (selectedItems.length > 1) {
				if (selectedItems.length > 100) {
					this.$wf.notify(this.$ct("you-can-only-send-up-to-x-sales"), "danger", 3000, "exclemation-triangle");
					return;
				}
			}else{
				item = this.getSelectedItem(item);
				if (!item) return;
				selectedItems = [item];
			}
			let message = this.$ctc("are-you-sure-you-want-to-send-x-documents", selectedItems.length, {count: selectedItems.length});
			let confirm = await this.$confirmBuilder().setWarningTitle().setMessage(message).show();
			if (!confirm) return;
			await SaleService.batchSendXmlToBookkeeper(selectedItems);
			if (selectedItems.length > 1) {
				this.$wf.notify(this.$ct("send-started-follow-in-notifications"), "info", 5000, "info-circle");
			}
			return;
			/*}
			item = this.getSelectedItem(item);
			if (this.validateSaldoDocuments(item)) {
				return;
			}
			this.toSendSale = await SaleService.getSale(item.ID);
			this.sendModal = true;*/
		},
		async sendPortal(item?: Sale) {
			item = this.getSelectedItem(item);
			if (!item) return;
			if (this.validateSaldoDocuments(item)) {
				return;
			}
			item = await SaleService.getSale(item.ID);
			this.clientPortalLink = await CustomerService.getClientPortalUrl(item.ContactID);
			this.toSendSale = item;
			this.sendPortalModal = true;
		},

		convertToCreditNote() {
			if (this.selectedItems.length == 0) return;
			this.convertToCreditNoteModal = true;
		},
		async doConvertToCreditNote(autoSettleCreditNote: boolean) {
			try {
				let result = await SaleService.convertToCreditNote(this.selectedItems.map(s => s.ID), autoSettleCreditNote);
				this.$wf.notify(this.$ctc("created-{amount}-creditnotes", result.length, {amount: result.length}), "success", 3000, "check");
			} finally {
				this.convertToCreditNoteModal = false;
			}
			this.updateView();
		},
		async sendViaPeppol(item?:Sale){
			item = this.getSelectedItem(item);
			if (!item) return;
			let sale = await SaleService.getSale(item.ID);
			this.toSendSale = sale;
			this.peppolModalOpen = true;
		},
		saveAs(sale:Sale) {
			if (this.selectedItems.length == 0){
				this.selectedItems.push(sale);
			}
			this.saveAsModal = true;
		},
		validateSaldoDocuments(item?: Sale): Boolean {
			if (!this.browseState) {
				return false;
			}
			if (this.browseState.browse.ID == 6) {
				if ((item as Sale).isSaldoDocument()) {
					this.$wf.dialog(this.$t("components.browse.saldo-warning"), this.$ct("common.Ok"), this.$ct("common.attention"), "info");
					return true;
				}
			}
			return false;
		},
		openChangeComputedFriendlyIdModal(event:Sale){
			this.changeFriendlyIdModalOpen = true;
			this.toSendSale = event || this.selectedItems[0];
		},
		openDeletedSalesModal(){
			this.deletedSalesModal = true;
		},
		openFillLedgerAccountsModal(sale?:Sale){
			let target = this.getSelectedItem(sale);
			if (this.selectedItems.length == 0 && target){
				this.selectedItems.push(target);
			}
			if (this.selectedItems.length == 0) return;
			this.fillLedgerAccountsModalOpen = true;
		},
		async checkCarpassStatus(sale?:Sale){
			sale = this.getSelectedItem(sale);
			if (!sale) return;
			if (!sale.CarpassRequestId) return;
			let observation = await CarpassService.getObservationStatus(sale.ID);
			sale.CarpassStatus = observation.Status;
			if (sale.CarpassStatus != "ISSUE" && sale.CarpassStatus != "ERROR") return;
			if (this.carpassInputModalState.isModalOpen()) return;
			await this.carpassInputModalState.showCarpassModalForCorrection(sale, observation);
		},
		async addCarpassDescription(sale?:Sale){
			sale = this.getSelectedItem(sale);
			if (!sale) return;
			if (!sale.CarpassRequestId) return;
			sale = await SaleService.getSale(sale.ID);
			this.carpassEditObservationDescriptionSale = sale;
		},
		async sendViaSendcloud(sale?:Sale){
			sale = this.getSelectedItem(sale);
			if (!sale) return;
			this.toSendViaSendcloudSale = await SaleService.getSale(sale.ID);
		},
		async openSendcloudParcelsList(sale?:Sale){
			sale = this.getSelectedItem(sale);
			if (!sale) return;
			this.sendcloudBrowseSale = await SaleService.getSale(sale.ID);
		},
		addDeposit(sale?:Sale){
			sale = this.getSelectedItem(sale);
			if (!sale) return;
			this.addDepositModalSale = sale;
		},
		removeDeletedSales(){
			if (!this.browseState) return;
			this.browseState.fetch();
		},
		onColClick(result:string, value:Sale){
			if (result == "edit-delivery-date"){
				this.editDeliveryDateModalSale = value;
			}
		},
		onSaleStatUpdate(saleId:number, statName:string, value:string) {
			console.log("Got statname update", statName, saleId);
			if (!this.browseState) return;
			if (this.browseState.queryResults.data.length > 20000) return;
			for (let item of this.browseState.queryResults.data as Sale[]) {
				if (item.ID != saleId) {
					continue;
				}
				if (statName == "last-send-date") {
					item.LastSendDate = newNullOrDate(value);
				}
				if (statName == "last-send-ubl-date") {
					item.LastSendUblDate = newNullOrDate(value);
				}
				if (statName == "last-print-date") {
					item.LastPrintDate = newNullOrDate(value);
				}
				if (statName == "last-send-via-peppol-date") {
					item.LastSentViaPeppolDate = newNullOrDate(value);
				}
				return;
			}
		},
		async fetchLastCtepTransaction(){
			try{
				let result = await CtepService.lastTranslaction();
				let ticketPdf = (await CtepService.downloadCtepTicketAsPdf(result.clientTicket)) as any as File;
				printPdf(ticketPdf, "ctep-result.pdf");
			}catch(err){
				if (typeof(err) == "object" && (err as any).getErrorMessage){
					let error = err as CtepEctError;
					this.$wf.dialog(error.getErrorMessage(), this.$ct("common.ok"), this.$ct("common.error"), "warning");
				}else{
					this.$wf.dialog(this.$ct("components.sales.CashierRefund.ctep-transaction-uncertain"), this.$ct("common.ok"), this.$ct("common.error"), "warning");
				}
				throw err;
			}
		}
	},
	created(){
		MainSocketService.on("/sale/stats-update", this.onSaleStatUpdate.bind(this), this);
	},
	destroyed() {
		SaleService.selectedSales = [];
		MainSocketService.offAll(this);
	},
	components: {
		AppBrowse,
		AppBankEdit,
		AppSaleReminder,
		AppSendSale,
		AppPublicLink,
		AppSendPortal,
		AppCreateUblArchiveModal,
		AppCreatePdfArchiveModal,
		AppSaveAsModal,
		AppReminderAutoSend,
		AppCombinedSaleSpinnerModal,
		AppCreateDagontvangstModal,
		AppSendViaPeppolModal,
		AppChangeFriendlyIdModal,
		AppDeletedSalesBrowse,
		AppCarpassInputModal,
		AppCarpassObservationDescriptionModal,
		AppCreateSendcloudParcel,
		AppSaleSendCloudParcels,
		AppAddDepositModal,
		AppSaleEditDeliveryDateModal,
		AppSaleSaveToModal,
		AppSalePrintSelectLayoutModal,
		AppFillLedgerAccountsModal,
		AppConvertToCreditNoteModal
	},
	i18nEx: {
		componentPrefix: "components.sales"
	}
});
